export class ExecutedMoovInstanceDTO{

    public id!: number;
    public customerId!: number;
    public status!: number;
    public awaitingApproval!: boolean;
    public moovDefinitionName!: string;
    public moovDefinitionId!: number;
    public moovConfigurationId!: number;
    public sourceFilename!: string;
    public resultFilename!: string;
    public moovFileId!: number;
    public added!: string;
    public completedAt!: string;
    public filePurgeAfter!: string;
    public filePurgedAt!: string;
}